const DEAD_LINK_REWRITES: Record<string, string> = {
  "https://www.aheadhealth.com/insights/coronary-calcium-score-a-guide-to-the-heart-scan-test":
    "/tests/calcium-score",
}

export function rewriteDeadLink(url: string): string {
  return DEAD_LINK_REWRITES[url] ?? url
}
